// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    getRegionalSalesRep as getRegionalSalesRepApi,
    RegionalSalesRepApiResponse,
} from "@stoneage/App/Services/RegionalSalesRep/regionalSalesRepService";

interface Props {
    apiResult: { successful: boolean; data?: RegionalSalesRepApiResponse };
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingRegionalSalesRep: HandlerType = props => {
    props.dispatch({
        type: "RegionalSalesRep/StartedLoading",
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRegionalSalesRepApi();
};

export const OnComplete: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        props.dispatch({
            type: "RegionalSalesRep/ComletedLoading",
            data: props.apiResult.data,
        } as any);
    }
};

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult);
        props.dispatch({
            type: "RegionalSalesRep/ComletedLoading",
            data: undefined,
        } as any);
    }
};

export const chain = [BeginLoadingRegionalSalesRep, RequestDataFromApi, OnComplete, OnError];

const getRegionalSalesRep = createHandlerChainRunner(chain, "GetRegionalSalesRep");
export default getRegionalSalesRep;
